<template>
  <div class="hero">
    <div class="wrap">
      <div class="text">Wooyun Drops</div>
      <div class="minitext">学而时习之，不亦说乎？</div>
    </div>
    <div class="search-unit">
      <input type="text" class="search-input" v-model="search">
    </div>
  </div>

  <drop-list :search.sync="search"></drop-list>
</template>

<style lang="styl" scoped>
  body
    background: #F5FCFF
  .hero
    background: #2D2D2D
    padding: 50px 0
    color: #FDF3E7
    font-weight: 300
    > .wrap
      line-height: 1.28
      max-width: 1260px
      margin: 0 auto
      padding: 0 20px
      > .text
        font-size: 64px
        text-align: center
      > .minitext
        margin-top: 10px
        font-size: 16px
        text-align: center
        text-transform: uppercase
  @media (max-width: 650px)
    .hero > .wrap > .text
        font-size: 34px
  .search-unit
    margin-top: 30px
    text-align: center
    > .search-input
      background: transparent url('../assets/search.png') no-repeat 10px center
      background-size: 16px 16px
      padding: 0 10px 0 35px
      font-size: 20px
      height: 40px
      background-color: #555
      border-radius: 4px
      color: white
      outline: none
      border: none
      width: 340px
      transition: background-color .3s ease
      &:focus
        background-color: #777
</style>

<script>
  import DropList from './DropList'

  export default{
    name: 'IndexContent',

    data () {
      return {
        search: ''
      }
    },

    components: {
      DropList
    }
  }
</script>



/** WEBPACK FOOTER **
 ** IndexContent.vue?50e79292
 **/